@if (showBackground) {
<div [ngStyle]="{
    'background-image': showBackground && defaults.componentTool === componentToolEnum.Mersy ? 'url(../../../assets/mersy_background.jpg)' : 
                       showBackground && defaults.componentTool === componentToolEnum.Rulebook ? 'url(../../../assets/rulebook_background.jpg)' : 'none',
    'background-size': 'cover',
    'background-position': 'center',
    'background-repeat': 'no-repeat',
    'height': '100%',
    'width': '100%',
    'position': 'fixed',
    'top': '0',
    'left': '0',
    'z-index': '-1'
}"></div>
}

<div class="landing-page-outer" style="background:none; position: relative; display: flex; flex-direction: column; flex: 1; overflow: hidden;">
    <div class="rulebook-wrapper" [class.mersy-header]="defaults.componentTool === componentToolEnum.Mersy" [class.rulebook-header]="defaults.componentTool !== componentToolEnum.Mersy">
        @if (defaults.componentTool !== componentToolEnum.Undefined) {
        <div class="rulebook-container">
            <img class="top-margin" src="../../../assets/border.svg" alt="Top border decoration" />
            <img class="bottom-margin" src="../../../assets/border.svg" alt="Bottom border decoration" />
            <h3>
                {{defaults.componentTool === componentToolEnum.Rulebook ? 'RULEBOOK EDITOR' : ''}}
                {{defaults.componentTool === componentToolEnum.Mersy && clusterName ? clusterName : ''}}
                {{defaults.componentTool === componentToolEnum.Mersy && !clusterName ? 'MERSY' : ''}}
            </h3>
        </div>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy) {
        <img class="tke-logo-header" src="../../../assets/tke_footer.png" alt="TKE Logo" />
        }
    </div>

    @if (showHeader) {
    <div class="cluster-header">
        @if (showBackButton) {
        <button class="back-button" 
                (click)="goBack()" 
                mat-icon-button 
                matTooltip="Back to Home">
            <mat-icon>arrow_back</mat-icon>
        </button>
        }
        <div class="cluster-info">
            @if (!clusterIcon.includes('img/')) {
            <mat-icon class="cluster-icon">{{clusterIcon}}</mat-icon>
            }
            @if (clusterIcon.includes('img/')) {
            <mat-icon class="cluster-icon">
                <img [src]="clusterIcon" class="icon-png" alt="Cluster Icon" />
            </mat-icon>
            }
            <h2 class="cluster-title">{{clusterName}}</h2>
        </div>
    </div>
    }

    <div class="tab-body">
        @if (items.length === 0) {
        <div class="no-modules-message">
            <mat-icon>info</mat-icon>
            <p>No modules available for this cluster.</p>
        </div>
        }

@if (items.length >= 1 && isClusterVisible(items)) {
<div id="landingpage-columns" 
     class="landingpage landingpage-columns" 
     [ngClass]="{'single-row-columns': items.length <= numberOfColumns}">
    @for (item of items; track item; let i = $index) {
    <div #itemRef
         class="bordered-div item"
         [ngClass]="getItemClass(i, item)"
         [style.width.%]="(100 / (items.length < numberOfColumns ? items.length : numberOfColumns)) - 2" 
         [style.max-width.%]="(100 / (items.length < numberOfColumns ? items.length : numberOfColumns)) - 2"
         [style.height.px]="uniformItemHeight">
        <div class="top-label">
            {{ getDisplayTitle(item) }}
        </div>
        @if (!isClusterView) {
        <span class="description">
          <markdown [data]="item.Description"></markdown>
        </span>
        }
        @if (isClusterView && item.ClusterComponents) {
        <div class="cluster-modules-list">
            <ul>
                @for (module of item.ClusterComponents; track module) {
                <li>
                    @if (module.IconName?.includes('img/')) {
                    <span class="module-icon-mask"
                          [style.mask-image]="'url(' + module.IconName + ')'"
                          [style.webkitMaskImage]="'url(' + module.IconName + ')'"
                          [attr.aria-hidden]="true"></span>
                    }
                    @if (!module.IconName?.includes('img/')) {
                    <mat-icon class="module-icon">{{module.IconName}}</mat-icon>
                    }
                    <span>{{module.DisplayName}}</span>
                </li>
                }
            </ul>
        </div>
        }
        @if (!isExternalLink(item.Route || '')) {
        <button class="button" 
                (click)="onItemClick(item)">
            Click here
            <mat-icon class='sidenav-icon'>settings_application</mat-icon>
        </button>
        }
        @if (isExternalLink(item.Route || '')) {
        <button class="button"
                (click)="onItemClick(item)">
            Click here
            <mat-icon class='sidenav-icon'>settings_application</mat-icon>
        </button>
        }
    </div>
    }
</div>
}

    </div>

    <div>
        @if (defaults.componentTool !== componentToolEnum.Mersy) {
        <img class="tke_footer" src="../../../assets/tke_footer.png" alt="TKE Footer" />
        }
    </div>
</div>
